"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Check(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", points: "14.299 2.293 15.713 3.707 6.354 13.066 1.293 8.004 2.707 6.59 6.354 10.237" })));
}
exports.default = Check;
//# sourceMappingURL=Check.js.map